import { render, staticRenderFns } from "./AboutCancer.vue?vue&type=template&id=71e7c3d5"
import script from "./AboutCancer.vue?vue&type=script&lang=js"
export * from "./AboutCancer.vue?vue&type=script&lang=js"
import style0 from "./AboutCancer.vue?vue&type=style&index=0&id=71e7c3d5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports